import { RETRYABLE_STATUS_CODES } from '../constants'

const NAME = 'HttpError'

export class HttpError extends Error {
  readonly status: number
  readonly statusText: string
  readonly url: string
  readonly method: string
  readonly responseBody: unknown
  readonly retryCount: number
  readonly isRetryable: boolean

  constructor(opts: {
    message: string
    status: number
    statusText: string
    url: string
    method: string
    responseBody?: unknown
    retryCount?: number
  }) {
    super(opts.message)
    this.name = NAME
    this.status = opts.status
    this.statusText = opts.statusText
    this.url = opts.url
    this.method = opts.method
    this.responseBody = opts.responseBody
    this.retryCount = opts.retryCount ?? 0
    this.isRetryable = (RETRYABLE_STATUS_CODES as readonly number[]).includes(opts.status)
  }
}
